
// @deprecated (initReviewsSlider) — slider config moved to:
//   assets/js/components/ui-components/slick-slider.js (preset "enterprise-reviews")
//   Template updated: templates/public/static/enterprise-landing/main-screeen.html.twig
//   NOTE: AdsServicesMarquee, toggleWhatIsEnterpriseVideo, toggleDashboardItems below are still active.
const { AdsServicesMarquee } = require("../components/ads-services-marquee");
// const { QuizApp } = require("../components/quiz-app");

export default class EnterpriseLandingPage {
  constructor() {
    this.$whatIsEnterpriseVideoPlaceholder = $(".js-what-is-enterprise-video-placeholder");
    this.$whatIsEnterpriseVideo = $(".js-what-is-enterprise-video");
    this.$whatIsEnterpriseVideoBtn = $(".js-what-is-enterprise-video-btn");
    this.$dashboardSectionItems = $(".js-dashboard-list-item");
    this.$dashboardSectionAdditionalItems = $(".js-dashboard-list-item-additional");
    this.$dashboardListToggle = $(".js-dashboard-list-toggle");
    this.adsServicesMarquee = new AdsServicesMarquee();
  }

  init() {
    this.handleEvents();
    this.adsServicesMarquee.initMarquee();
    this.toggleWhatIsEnterpriseVideo();
  }

  toggleWhatIsEnterpriseVideo() {
    this.$whatIsEnterpriseVideoBtn.on("click", () => {
      this.$whatIsEnterpriseVideoBtn.addClass("out");
      this.$whatIsEnterpriseVideo.addClass("in");
      this.$whatIsEnterpriseVideoPlaceholder.addClass("out");

      const currentSrc = this.$whatIsEnterpriseVideo.attr("src");

      if (!currentSrc.includes("autoplay=1")) {
        const separator = currentSrc.includes("?") ? "&" : "?";
        this.$whatIsEnterpriseVideo.attr("src", currentSrc + separator + "autoplay=1");
      }
    });
  }

  toggleDashboardItems() {
    this.$dashboardSectionAdditionalItems.each(function () {
      $(this).toggleClass("hidden");
    });

    const $hiddenItems = this.$dashboardSectionAdditionalItems.filter(".hidden");

    if ($hiddenItems.length > 0) {
      this.$dashboardListToggle.text(_t("Show more")).removeClass("open");
    } else {
      this.$dashboardListToggle.text(_t("Show less")).addClass("open");
    }
  }

  handleEvents() {
    this.$dashboardListToggle.on("click", () => {
      this.toggleDashboardItems();
    });
  }
}

// const quizApp = new QuizApp();
// quizApp.init();

document.addEventListener("DOMContentLoaded", () => {
  const enterpriseLandingPage = new EnterpriseLandingPage();
  enterpriseLandingPage.init();
});
